import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreTaskGroupModule } from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { TasklistsComponent } from './tasklists.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreTaskGroupModule,
    FeatureFlagsModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [TasklistsComponent],
  exports: [TasklistsComponent],
})
export class TasklistsModule {}
